import { HubFeature } from '@ats/api/cm';
import { LocDef, LocDefs, LocMap } from '@cm/core/localization';

const pathStart = 'Catalogs|Credentials|Logo|Form|';
const sharedProperties: Pick<LocDef, 'shared' | 'htmlAllowed' | 'feature' | 'portal'> = {
	shared: false,
	htmlAllowed: false,
	feature: HubFeature.Credential,
	portal: 'SP',
};

type LocNameStart = 'SPCatalogCertLogoForm';
export type SPCatalogCertLogoFormLocNames =
	| `${LocNameStart}NotificationChangesSaved`
	| `${LocNameStart}LabelZippedLogoFile`
	| `${LocNameStart}ContentZippedLogoFileHint`
	| `${LocNameStart}ErrorFileSize`
	| `${LocNameStart}ErrorFileType`
	| `${LocNameStart}LabelLogoDownloadEnabled`
	| `${LocNameStart}ContentLogoDownloadEnabledHint`
	| `${LocNameStart}ButtonCancel`
	| `${LocNameStart}ButtonUpdate`;

export const spCatalogCertLogoFormLocs: LocDefs<SPCatalogCertLogoFormLocNames> = {
	SPCatalogCertLogoFormNotificationChangesSaved: {
		defaultValue: 'Changes saved',
		description: 'Changes saved notification',
		displayPath: `${pathStart}Changes saved`,
		displayType: 'Notification',
		legacyName: 'Credential/CatalogsCredential.Logo.Notification.ChangesSaved',
		...sharedProperties,
	},
	SPCatalogCertLogoFormLabelZippedLogoFile: {
		defaultValue: 'Zipped Logo File',
		description: 'Label for: Zipped Logo File.',
		displayPath: `${pathStart}Zipped Logo File`,
		displayType: 'Label',
		legacyName: 'Credential/CatalogsCredential.Logo.FieldLabel.ZippedLogoFile',
		...sharedProperties,
	},
	SPCatalogCertLogoFormContentZippedLogoFileHint: {
		defaultValue: 'The file must be a ZIP format and not exceed 20mb',
		description: 'Hint for: Zipped Logo File.',
		displayPath: `${pathStart}Zipped Logo File Hint`,
		displayType: 'Content',
		legacyName: 'Credential/CatalogsCredential.Logo.FieldHint.FileHint',
		...sharedProperties,
	},
	SPCatalogCertLogoFormErrorFileSize: {
		defaultValue: 'The file must not exceed 20mb',
		description: 'Error saying the file is too large.',
		displayPath: `${pathStart}Zipped Logo File Too Large`,
		displayType: 'Error',
		legacyName: 'Credential/CatalogsCredential.Logo.FieldError.FileSize',
		...sharedProperties,
	},
	SPCatalogCertLogoFormErrorFileType: {
		defaultValue: 'The file must be a ZIP format',
		description: 'Error saying the file is the wrong type.',
		displayPath: `${pathStart}Zipped Logo File Wrong Type`,
		displayType: 'Error',
		legacyName: 'Credential/CatalogsCredential.Logo.FieldError.FileType',
		...sharedProperties,
	},
	SPCatalogCertLogoFormLabelLogoDownloadEnabled: {
		defaultValue: 'Logo Download Enabled',
		description: 'Label for: Logo Download Enabled.',
		displayPath: `${pathStart}Logo Download Enabled`,
		displayType: 'Label',
		legacyName: 'Credential/CatalogsCredential.Logo.FieldLabel.DownloadEnabled',
		...sharedProperties,
	},
	SPCatalogCertLogoFormContentLogoDownloadEnabledHint: {
		defaultValue: 'A file must be attached or uploaded before editing',
		description: 'Hint for: Logo Download Enabled.',
		displayPath: `${pathStart}Logo Download Enabled Hint`,
		displayType: 'Content',
		legacyName: 'Credential/CatalogsCredential.Logo.FieldHint.EnableHint',
		...sharedProperties,
	},
	SPCatalogCertLogoFormButtonCancel: {
		defaultValue: 'Cancel',
		description: 'Cancel button',
		displayPath: `${pathStart}Cancel`,
		displayType: 'Button',
		legacyName: 'Credential/CatalogsCredential.Logo.Button.Cancel',
		...sharedProperties,
	},
	SPCatalogCertLogoFormButtonUpdate: {
		defaultValue: 'Update',
		description: 'Update button',
		displayPath: `${pathStart}Update`,
		displayType: 'Button',
		legacyName: 'Credential/CatalogsCredential.Logo.Button.Update',
		...sharedProperties,
	},
};

export type SPCatalogCertLogoFormLocType = LocMap<SPCatalogCertLogoFormLocNames>;
